import React, { useState } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';

const assignedIds = vehicle => vehicle.assigned_driver_ids || (vehicle.driver_id ? [vehicle.driver_id] : []);

export default function VehicleAssignments({ vehicle, drivers, onChanged }) {
  const [edit, setEdit] = useState(null);
  const [saving, setSaving] = useState(false);
  const ids = assignedIds(vehicle);
  const available = drivers.filter(d => d.approval_status === 'approved');
  const names = vehicle.assigned_drivers || drivers.filter(d => ids.includes(d.id));
  const options = drivers.filter(d => d.approval_status === 'approved' || edit?.ids.includes(d.id));
  const allSelected = available.length > 0 && available.every(d => edit?.ids.includes(d.id));
  const begin = () => setEdit({ ids: [...ids], revision: vehicle.assignment_revision ?? 0, owner: vehicle.driver_id ?? null });
  const save = async (selection = edit) => {
    if (saving) return;
    setSaving(true);
    try {
      await api.patch(`/partners/vehicles/${vehicle.id}/assignments`, {
        driver_ids: selection.ids,
        expected_assignment_revision: selection.revision,
        expected_owner_driver_id: selection.owner,
      });
      toast.success(selection.ids.length ? 'Fahrerzuweisung gespeichert' : 'Zuweisung aufgehoben');
      setEdit(null);
      await onChanged();
    } catch (error) {
      const data = error.response?.data;
      toast.error(data?.message || (data?.error === 'vehicle_changed'
        ? 'Die Zuweisung wurde inzwischen geändert. Bitte prüfe den aktuellen Stand.'
        : 'Fahrerzuweisung konnte nicht gespeichert werden. Bitte erneut versuchen.'));
      if (data?.error === 'vehicle_changed') { setEdit(null); await onChanged(); }
    } finally { setSaving(false); }
  };
  return <section aria-label="Fahrerzuweisung" style={{ borderTop: '1px solid #eee', paddingTop: 14 }}>
    <div style={{ fontSize: 12, fontWeight: 700, color: '#6b7280', marginBottom: 8 }}>Fahrerzuweisung</div>
    {vehicle.approval_status !== 'approved' ? <p>Fahrzeug muss erst vom Admin genehmigt werden.</p> : edit ? <>
      <fieldset disabled={saving} style={{ border: 0, padding: 0, margin: 0 }}>
        <legend className="sr-only">Fahrer auswählen</legend>
        <label style={{ display: 'block', padding: '8px 0', fontWeight: 700 }}>
          <input type="checkbox" checked={allSelected} disabled={!available.length}
            onChange={e => setEdit({ ...edit, ids: e.target.checked ? available.map(d => d.id) : [] })} /> Alle
        </label>
        <div style={{ maxHeight: 240, overflowY: 'auto' }}>
          {options.map(d => <label key={d.id} style={{ display: 'block', padding: '8px 0' }}>
            <input type="checkbox" checked={edit.ids.includes(d.id)}
              onChange={e => setEdit({ ...edit, ids: e.target.checked ? [...edit.ids, d.id] : edit.ids.filter(id => id !== d.id) })} /> {d.name}
            {d.approval_status !== 'approved' && ' (nicht freigegeben)'}
          </label>)}
        </div>
        <p style={{ fontSize: 12, color: '#6b7280' }}>Ausgewählte Fahrer können dieses Auto in der Fahrer-App wählen. Gleichzeitig nutzt es ein Fahrer. „Alle“ wählt die derzeit freigegebenen Fahrer.</p>
        <button onClick={() => save()} style={{ padding: '8px 14px', borderRadius: 8, background: '#111', color: '#fff' }}>Speichern</button>{' '}
        <button onClick={() => setEdit(null)} style={{ padding: '8px 14px' }}>Abbrechen</button>
      </fieldset>
    </> : <>
      <div style={{ marginBottom: 10 }}>{names.length ? names.map(d => d.name).join(', ') : ids.length ? `${ids.length} Fahrer zugewiesen` : 'Keine Fahrer zugewiesen'}</div>
      <button onClick={begin} disabled={saving || (!available.length && !ids.length)} style={{ padding: '8px 12px', borderRadius: 8, background: '#f3f4f6' }}>
        {ids.length ? 'Ändern' : 'Fahrer zuweisen'}
      </button>
      {!!ids.length && <button data-testid={`unassign-${vehicle.id}`} disabled={saving}
        onClick={() => save({ ids: [], revision: vehicle.assignment_revision ?? 0, owner: vehicle.driver_id ?? null })}
        style={{ padding: '8px 12px', color: '#b91c1c' }}>Zuweisung aufheben</button>}
      {!available.length && <p style={{ fontSize: 12, color: '#6b7280' }}>Keine genehmigten Fahrer in der Flotte</p>}
    </>}
  </section>;
}
